import template from './_warning.pug'

// @vue/component
export default {
  template: template(),
  methods: {
    onBack() {
      this.$emit('deregister-finished')
    }
  }
}
